export default {
  errorsRootKey: 'callTrackingProviders',
  resource: 'callTrackingProviders',
  actions: ['index']
}
